import React, {Component} from 'react'
import {Row, Col, Form, FormGroup, Label, Input, FormText, Button} from 'reactstrap'
import {
    AvForm,
    AvField,
    AvGroup,
    AvInput,
    AvFeedback
} from 'availity-reactstrap-validation'
import PropTypes from 'prop-types'
import {Mutation} from 'react-apollo'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

import PermissionsCheckboxList from "../permissions/PermissionsCheckboxList"
import upsertUserRoleMutation from '../../../queries/server/mutations/upsert_user_role'
import updateUserRoleLocalMutation from '../../../queries/client_side/mutations/edit_user_role'
import {checkPermission, USER_PERMISSIONS_CAN_CHANGE_USER_ROLE_PERMISSIONS} from "../../../lib/permissions";
import {toast} from "react-toastify";

export default class UserRoleForm extends Component {

    constructor(props) {
        super(props)

        this.state = {
            ...props
        }
    }

    selectAll = (permissions) => {
        this.setState({permissions})
    }

    render() {

        const {user_role_id, description, permissions} = this.state

        return (

            <Mutation mutation={upsertUserRoleMutation}>
                {(upsertUserRoleFunc, {loading}) => (
                    <Mutation mutation={updateUserRoleLocalMutation}>
                        {(updateUserRoleLocalMutationFunc) => (
                            <AvForm
                                onValidSubmit={() => {
                                    upsertUserRoleFunc({
                                        variables: {
                                            data: {
                                                user_role_id,
                                                description,
                                                permissions: permissions.map(({permission_id, access}) => {
                                                    return {
                                                        permission_id,
                                                        access
                                                    }
                                                })
                                            }
                                        }
                                    })
                                        .then(({data}) => {
                                            console.log('updated', data)
                                            updateUserRoleLocalMutationFunc({
                                                variables: {
                                                    data: data.upsert_user_role_with_permissions
                                                }
                                            })
                                            toast.success('User Details Updated', {autoClose: 2000})
                                        })
                                        .catch(e => toast.error(e.message, {autoClose: false}))
                                }}
                            >
                                <AvField
                                    required
                                    label="Description*"
                                    errorMessage="Required"
                                    type="text"
                                    name="name"
                                    id="name"
                                    bsSize="sm"
                                    value={description}
                                    onChange={(evt) => this.setState({description: evt.target.value})}
                                />
                                {checkPermission(USER_PERMISSIONS_CAN_CHANGE_USER_ROLE_PERMISSIONS) &&
                                <div>
                                    <Label for="permissions">Permissions</Label>
                                    <FormGroup check>
                                        <PermissionsCheckboxList
                                            name="permissions"
                                            selectedPermissions={permissions}
                                            onSelectAll={this.selectAll}
                                            onChange={(permission_id, access) => {

                                                const newData = {permission_id, access}

                                                const index = permissions.findIndex(p => p.permission_id === permission_id)

                                                let newPermissions = [...permissions]

                                                if (index === -1) {
                                                    newPermissions.push(newData)
                                                }
                                                else {
                                                    newPermissions = [
                                                        ...permissions.slice(0, index),
                                                        {permission_id, access},
                                                        ...permissions.slice(index + 1)
                                                    ]
                                                }

                                                this.setState({permissions: newPermissions})

                                            }}
                                        />
                                    </FormGroup>
                                </div>
                                }

                                <div className="d-flex justify-content-end align-content-end" style={{flex: 1}}>
                                    <Button
                                        size="sm"
                                        color="success"
                                        disabled={loading}

                                    >
                                        <FontAwesomeIcon
                                            color="#fff"
                                            icon={loading ? 'spinner' : 'save'}
                                            spin={loading}
                                        />{' '}
                                        {loading ? 'Saving...' : 'Save User Role'}
                                    </Button>
                                </div>

                            </AvForm>
                        )}

                    </Mutation>
                )}

            </Mutation>
        )

    }

}

UserRoleForm.propTypes = {
    user_role_id: PropTypes.number.isRequired,
    description: PropTypes.string.isRequired,
    permissions: PropTypes.array
}